import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.174 14.833H5.828c-3.274 0-4.674-1.4-4.674-4.673v-.087c0-2.96 1.167-4.386 3.78-4.633.267-.02.52.18.547.453a.5.5 0 0 1-.453.547c-2.094.193-2.874 1.18-2.874 3.64v.086c0 2.714.96 3.674 3.674 3.674h4.346c2.714 0 3.674-.96 3.674-3.674v-.086c0-2.473-.794-3.46-2.927-3.64a.5.5 0 0 1 .087-.993c2.653.226 3.84 1.66 3.84 4.64v.086c0 3.26-1.4 4.66-4.674 4.66"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 10.5a.504.504 0 0 1-.5-.5V2.413c0-.273.227-.5.5-.5s.5.227.5.5V10c0 .273-.227.5-.5.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.233 4.4a.5.5 0 0 1-.354-.147L8 2.373l-1.88 1.88a.503.503 0 0 1-.706 0 .503.503 0 0 1 0-.707l2.233-2.233a.503.503 0 0 1 .707 0l2.233 2.233a.503.503 0 0 1 0 .707.48.48 0 0 1-.353.147"
    }, null, -1)
  ]))]))
}
export default { render: render }